import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  fullscreenPages: {
    flex: 1,
    flexDirection: 'row',
  },
});
